import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useInPortcoFilter } from './useInPortcoFilter';

export const InPortcoFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, inPortcoOptions } = useInPortcoFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ inPortco: value || { label: 'Any', value: 'any' } }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="inPortco"
          label="Currently at network companies"
          placeholder="Any"
          size="small"
          component={FormSelect}
          options={inPortcoOptions}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

InPortcoFilter.propTypes = {
  value: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
};

InPortcoFilter.defaultProps = {
  value: { label: 'Any', value: 'any' },
};
